export default __webpack_public_path__ + "static/media/client-23.d0d5f14d.png";